// Global OAuth callback redirect — handles the stable /oauth/mcp/callback path
// and forwards to the branch-prefixed settings callback route.
// The redirect URI registered with OAuth providers is always /oauth/mcp/callback
// regardless of branch deployment, and this redirect forwards to the real handler.
// This must run before any other imports to avoid unnecessary work.
if (window.location.pathname === "/oauth/mcp/callback") {
  const branchPrefix = import.meta.env.VITE_BRANCH_NAME
    ? `/${import.meta.env.VITE_BRANCH_NAME}`
    : "";
  window.location.replace(
    `${branchPrefix}/settings/ai/mcp-callback${window.location.search}`,
  );
}

// This module must be imported before any other module that defines Zod schemas.
// eslint-disable-next-line import/order
import "./zodConfig";

import "@fontsource/roboto/100.css";
import "@fontsource/roboto/200.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/600.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/800.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto-mono/500.css";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/App/styles/globals.css";
import "@/App/styles/theme.css";
import { configureAmplify } from "@/shared/auth";
import "@/shared/foundation/styles/colors.css";
import "@/shared/foundation/styles/spacing.css";
import "@/shared/foundation/styles/typography.css";
import "@/shared/foundation/styles/utilities.css";

import { configureMonaco } from "./App/configureMonaco";

await configureAmplify();

// Setup Monaco code editor but doesn't load it until it's needed
configureMonaco();

dayjs.extend(duration);
dayjs.extend(relativeTime);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
